import React from 'react';
import { cn } from '@/lib/utils';

export interface VideoGridProps {
  children: React.ReactNode;
  className?: string;
}

export function VideoGrid({ children, className }: VideoGridProps) {
  return (
    <div 
      className={cn(
        'grid',
        'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
        'gap-4 md:gap-5',
        className
      )}
    >
      {children}
    </div>
  );
}
